/** Gedeelde stijl voor secundaire actie-knoppen (focus, timer) — paars */
export const actionIconButtonSx = {
  bgcolor: 'secondary.main',
  color: 'common.white',
  '&:hover': { bgcolor: 'secondary.dark' },
};
